import { Link } from 'react-router-dom';
import { FaFacebookF, FaInstagram, FaTiktok, FaLinkedinIn, FaPinterestP, FaYoutube } from 'react-icons/fa';

export default function Footer({ variant = 'minimal' }) {
  if (variant === 'auth') {
    return (
      <footer className="pb-6 mt-auto bg-transparent border-t border-gray-200/30 dark:border-gray-700/30">
        <div className="max-w-6xl mx-auto px-6">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-xs text-slate-400 dark:text-slate-500 pt-4">
            <Link 
              to="/privacy" 
              className="hover:text-primary-600 dark:hover:text-primary-400 transition-colors"
            >
              Politika privatnosti
            </Link>
            <span className="hidden sm:inline">|</span>
            <Link 
              to="/terms" 
              className="hover:text-primary-600 dark:hover:text-primary-400 transition-colors"
            >
              Uslovi korišćenja
            </Link>
          </div>
        </div>
      </footer>
    );
  }

  if (variant === 'landing') {
    return (
      <footer className="mt-16 bg-white/60 dark:bg-gray-900/60 backdrop-blur-sm border-t border-white/60 dark:border-gray-700/60">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="grid gap-10 md:grid-cols-4">
            <div className="space-y-4">
              <p className="text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400">
                Nannity
              </p>
              <ul className="space-y-2 text-sm text-gray-700 dark:text-gray-300">
                <li><Link to="/register" className="hover:text-primary-600 dark:hover:text-primary-400">Kako funkcioniše</Link></li>
                <li><Link to="/login" className="hover:text-primary-600 dark:hover:text-primary-400">Pomoć</Link></li>
                <li><Link to="/terms" className="hover:text-primary-600 dark:hover:text-primary-400">Uslovi korišćenja</Link></li>
                <li><Link to="/privacy" className="hover:text-primary-600 dark:hover:text-primary-400">Privatnost</Link></li>
                <li><Link to="/dashboard/jobs" className="hover:text-primary-600 dark:hover:text-primary-400">Nannity za posao</Link></li>
              </ul>
            </div>
            <div className="space-y-4">
              <p className="text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400">
                Saznajte
              </p>
              <ul className="space-y-2 text-sm text-gray-700 dark:text-gray-300">
                <li><Link to="/register" className="hover:text-primary-600 dark:hover:text-primary-400">O nama</Link></li>
                <li><Link to="/register" className="hover:text-primary-600 dark:hover:text-primary-400">Saveti i članci</Link></li>
                <li><Link to="/register" className="hover:text-primary-600 dark:hover:text-primary-400">Poverenje i bezbednost</Link></li>
                <li><Link to="/register" className="hover:text-primary-600 dark:hover:text-primary-400">Partneri</Link></li>
                <li><Link to="/register" className="hover:text-primary-600 dark:hover:text-primary-400">Nannity za posebne potrebe</Link></li>
              </ul>
            </div>
            <div className="space-y-4">
              <p className="text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400">
                Popularno
              </p>
              <ul className="space-y-2 text-sm text-gray-700 dark:text-gray-300">
                <li><Link to="/register" className="hover:text-primary-600 dark:hover:text-primary-400">Bebisiterka Beograd</Link></li>
                <li><Link to="/register" className="hover:text-primary-600 dark:hover:text-primary-400">Bebisiterka Novi Sad</Link></li>
                <li><Link to="/register" className="hover:text-primary-600 dark:hover:text-primary-400">Bebisiterka Niš</Link></li>
                <li><Link to="/register" className="hover:text-primary-600 dark:hover:text-primary-400">Bebisiterka Kragujevac</Link></li>
                <li><Link to="/register" className="hover:text-primary-600 dark:hover:text-primary-400">Poslovi čuvanja dece</Link></li>
              </ul>
            </div>
            <div className="space-y-4">
              <p className="text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400">
                Pratite nas na
              </p>
              <div className="flex flex-wrap gap-3">
                {[FaFacebookF, FaInstagram, FaTiktok, FaLinkedinIn, FaPinterestP, FaYoutube].map((Icon, index) => (
                  <a
                    key={index}
                    href="#"
                    className="w-10 h-10 rounded-full bg-white/80 dark:bg-gray-800/80 border border-white/60 dark:border-gray-700/60 flex items-center justify-center text-primary-600 dark:text-primary-400 hover:shadow-sm transition-shadow"
                    aria-label="Social link"
                  >
                    <Icon className="text-base" />
                  </a>
                ))}
              </div>
              <p className="text-xs text-gray-500 dark:text-gray-400">
                © {new Date().getFullYear()} Nannity
              </p>
            </div>
          </div>
        </div>
      </footer>
    );
  }

  return (
    <footer className="py-4 mt-auto bg-transparent border-t border-gray-200/50 dark:border-gray-700/50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center text-sm text-gray-600 dark:text-gray-400">
          <span>© {new Date().getFullYear()} </span>
          <a 
            href="https://mnocompany.com" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="hover:text-primary-600 dark:hover:text-primary-400 transition-colors"
          >
            mnocompany.com
          </a>
          <span>. Sva prava zadržana. </span>
          <Link 
            to="/privacy" 
            className="hover:text-primary-600 dark:hover:text-primary-400 transition-colors ml-2"
          >
            Politika privatnosti
          </Link>
          <span className="mx-2">|</span>
          <Link 
            to="/terms" 
            className="hover:text-primary-600 dark:hover:text-primary-400 transition-colors"
          >
            Uslovi korišćenja
          </Link>
        </div>
      </div>
    </footer>
  );
}

